/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*
* Who a service request can be assigned to - the agent's own staff and any OMC member with a login,
* served as one list by /requestOwners so the two audiences are a column to search on rather than a
* choice to make before picking.
*/
import { AbstractObject } from '@src/app/model/abstract-object';
import { FieldSet, LAYOUT_OPTIONS } from '@src/app/shared/form/field-set/field-set.component';
import { FormConfig } from '@src/app/shared/form/FormConfig';
import { FormTextComponent } from '@src/app/shared/form/form-text/form-text.component';

export class RequestOwner extends AbstractObject {
    /** 'Agent' or 'OMC' - which side of the relationship this owner sits on */
    type: string;

    static pickDialogFormConfig(): FormConfig {
        return new FormConfig({
            fieldSet: new FieldSet({
                fields: [
                    FormTextComponent.make('Name', 'name'),
                    FormTextComponent.make('Team', 'type'),
                ],
                formLayout: LAYOUT_OPTIONS.singleCol,
            }),
            title: $localize`Request Owners`,
            mode: 'list',
        });
    }
}
